import { sendFileMessage } from './sendFileMessage';
import { EUploadFilesStatus, TMessageFiles } from '../../types/file';
import { TThunkAction } from '../../types/redux/thunk';
import { createWsMessage, createWsReplyMessage } from '../../utils/message';
import { setSendMessagePending } from '../sendMessage';
import { sendWsMessage } from '../wsMessage';
import { IWsMessageReply } from '../wsMessage/types';

type TRetrySendFileMessage = {
  pendingFiles: TMessageFiles;
  chatId: string;
  messageId: string;
  reply?: IWsMessageReply | null;
};

export const retrySendFileMessage =
  ({ chatId, messageId, pendingFiles, reply }: TRetrySendFileMessage): TThunkAction<void> =>
  async (dispatch, getState, context) => {
    const {
      user: { userId },
    } = getState();

    // Если загрузка файла отвалилась на шаге 1 при отправке в мск files
    if (pendingFiles.status === EUploadFilesStatus.Failed && pendingFiles.blobFiles?.length) {
      const file = pendingFiles.blobFiles[0].file;
      const type = pendingFiles.blobFiles[0].type;

      dispatch(sendFileMessage({ file, chatId, type, messageId, reply }));

      return;
    }

    // Если загрузка файла отвалилась на шаге 2 при отправке по сокету
    if (pendingFiles.status === EUploadFilesStatus.Succeed && pendingFiles.uploadedFiles?.length) {
      const messageReply = createWsReplyMessage({
        messagesMap: context.custom.messagesMap,
        replyToMessageId: reply?.messageId,
      });

      const message = createWsMessage({
        uid: messageId,
        type: 'textAndFiles',
        chatId,
        userId,
        reply: messageReply,
      });

      dispatch(setSendMessagePending({ message, messageId, messagesMap: context.custom.messagesMap }));
      dispatch(sendWsMessage({ message, files: pendingFiles.uploadedFiles, reply }));

      return;
    }
  };
